module.exports = __webpack_public_path__ + "static/media/Pe-icon-7-stroke.71394c0c.eot";